import type { ProductCategory, ProductUpdate, UpdateCategory } from '@product-updates/shared-types';

export interface Badge {
  category: ProductCategory | UpdateCategory;
  type: 'product' | 'update';
}

export function buildBadges(article: ProductUpdate): Badge[] {
  const badges: Badge[] = [];

  // New first
  if (article.updateCategories.includes('New')) {
    badges.push({ category: 'New', type: 'update' });
  }

  // Product categories
  for (const category of article.productCategories) {
    badges.push({ category, type: 'product' });
  }

  // Update categories (excluding New)
  for (const category of article.updateCategories) {
    if (category !== 'New') {
      badges.push({ category, type: 'update' });
    }
  }

  return badges;
}
